import 'core-js/stable/number';
import 'core-js/stable/string/repeat';
import Swiper from 'swiper/bundle';

const logoSlider = () => {
  new Swiper('#swiper-banks', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 50,
    // grabCursor: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      // when window width is >= 320px
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 4,
        // spaceBetween: 40,
      },
      1200: {
        slidesPerView: 5,
        // spaceBetween: 40,
      },
      1400: {
        slidesPerView: 6,
        // spaceBetween: 40,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

export default logoSlider;
